import TableHeader from "../../../../components/Table/TableHeader";
import Table from "../../../../components/Table/Table";
import TableContainer from "../../../../components/Table/TableContainer";
import TableCell from "../../../../components/Table/TableCell";
import TableBody from "../../../../components/Table/TableBody";
import TableRow from "../../../../components/Table/TableRow";
import Icon from "../../../../components/Icon/Icon";

export default function BenefitsTable({className,table, ...props}) {

    function getNumberOfRows() {
        let rows = 0;
        Object.keys(table).map((key, index) => {
            if (table[key].length > rows) {
                rows = table[key].length;
            }
        })
        return rows;
    }

    function GetCellComponent(data) {
        switch (data) {
            case "X":
                return <Icon name={"red-cross"} className={"h-4"}/>
            case "T":
                return <Icon name={"blue-tick"}  className={"h-4"}/>
            default:
                return data;
        }


    }

    return (
        <div className={`lg:w-1/2  overflow-auto ${className}`}>
            <TableContainer className={"max-w-[80vw]"}>
                <Table>
                    <TableHeader className={"bg-tertiary-900 "}>
                        <tr>
                            {
                                Object.keys(table).map((key, index) => {
                                    return <TableCell className={"text-white font-bold"} key={index}>{key}</TableCell>
                                })
                            }

                        </tr>
                    </TableHeader>

                    <TableBody>
                        {
                            new Array(getNumberOfRows()).fill(0).map((item, index) => {
                                return (
                                    <TableRow key={index}>
                                        {
                                            Object.keys(table).map((key, index2) => {
                                                return <TableCell
                                                    key={index2}>{GetCellComponent(table[key][index])}</TableCell>
                                            })
                                        }

                                    </TableRow>
                                )
                            })

                        }


                    </TableBody>
                </Table>
            </TableContainer>
        </div>

    )
}